import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

const route = 'UNITS_IMPORT';

// Initial state
const initialState = {
  openImport: false,
  loading: false,
  importResponse: null,
  error: null,
  fileKey: null,
  delimiter: '',
  importNotification: null,
};

// Async thunk for importing units
export const importUnits = createAsyncThunk(
  `${route}/importUnits`,
  async (payload, { rejectWithValue }) => {
    try {
      const { fileKey, delimiter } = payload;

      const query = `
        mutation importUnits ($fileKey: String!, $delimiter: String!) {
          importUnits (fileKey: $fileKey, delimiter: $delimiter) {
            stepFunctionId
            transactionId
            transactionType
            processStartDate
          }
        }
      `;

      const response = await clientMutation(
        query,
        {
          fileKey,
          delimiter,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (!response || !response.importUnits) {
        throw new Error('Error while importing units', response.error);
      }

      return response.importUnits;
    } catch (exc) {
      ExceptionManager(
        exc,
        'modules/fleet/components/ModalImportUnits/redux/slice',
        'importUnits'
      );
      return rejectWithValue(exc.error);
    }
  }
);

// Slice
const unitsImportSlice = createSlice({
  name: route,
  initialState,
  reducers: {
    // Open/close modal actions
    openImportUnitsModal: (state, action) => {
      state.openImport = action.payload;
      if (!action.payload) {
        // Reset state when closing modal
        state.importResponse = null;
        state.error = null;
        state.fileKey = null;
        state.importNotification = null;
      }
    },
    
    // Set file key for import
    setFileKeyUnit: (state, action) => {
      state.fileKey = action.payload;
    },
    
    // Set delimiter
    setDelimiterUnit: (state, action) => {
      state.delimiter = action.payload;
    },

    setImportNotification: (state, action) => {
      // Add validation for notification payload structure
      const notification = action.payload;
      if (notification && typeof notification === 'object') {
        state.importNotification = notification;
      } else {
        state.importNotification = null;
      }
    },
    
    // Reset import state
    resetImportStateUnit: (state) => {
      state.loading = false;
      state.importResponse = null;
      state.error = null;
      state.fileKey = null;
      state.delimiter = '';
      state.importNotification = null;
    },
    
    // Clear error
    clearErrorUnit: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Import units pending
      .addCase(importUnits.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.importResponse = null;
      })
      // Import units fulfilled
      .addCase(importUnits.fulfilled, (state, action) => {
        state.loading = false;
        state.importResponse = action.payload;
        state.error = null;
      })
      // Import units rejected
      .addCase(importUnits.rejected, (state, action) => {
        state.loading = false;
        state.importResponse = null;
        state.error = action.payload || 'Import failed';
      });
  },
});

export const {actions, reducer} = unitsImportSlice;

export const {openImportUnitsModal, setFileKeyUnit, setDelimiterUnit, resetImportStateUnit, clearErrorUnit, setImportNotification} = actions;

export default reducer;

// // Export actions
// export const {
//   openImportUnitsModal,
//   setFileKeyUnit,
//   setDelimiterUnit,
//   resetImportStateUnit,
//   clearErrorUnit,
// } = unitsImportSlice.actions;

// // Export reducer
// export default unitsImportSlice.reducer;